import { JsonTree } from "./JsonTree";
import type { StoryMeta } from "@features/devtools/registry/types";

type Props = React.ComponentProps<typeof JsonTree>;

const sample = {
  id: 1,
  name: "Alpha",
  active: true,
  scores: [1, 2, 3, 4],
  meta: { createdAt: new Date().toISOString(), tags: ["one", "two"] },
};

const meta: StoryMeta<Props> = {
  id: "output/JsonTree",
  title: "JsonTree",
  group: "Shared/Data",
  component: JsonTree,
  description: "Tree view for inspecting JSON values.",
  defaultProps: {
    data: sample,
    maxDepth: 6,
    search: "",
  },
  controls: {
    search: { type: "text", label: "Search" },
    maxDepth: { type: "number", min: 1, max: 20, step: 1 },
    data: { type: "json", label: "Data" },
  },
  variants: [
    { name: "Small", props: { data: sample } },
    {
      name: "Large array",
      props: { data: Array.from({ length: 100 }, (_, i) => ({ id: i + 1, value: Math.random() })) },
    },
  ],
};

export default meta;

